jQuery( function($) {

    var $body = $('body');
    var $cards = $('.js-card');
    var $top_all = $cards.closest('.grilla__top');
    var $bottom_all = $cards.closest('.grilla__bottom');
    var $seccion_bottom_all = $cards.closest('.grilla__right');

    var $btn_close = $('.js-card__close');

    $cards.addClass('image-visible');

    function close_all_cards(grilla) {
        grilla.attr('class', 'grilla');
        $cards.removeClass('open');
        $top_all.removeClass('is-open');
        $bottom_all.removeClass('is-open');
        $seccion_bottom_all.removeClass('is-here');
        $cards.addClass('image-visible');

        var videos = $cards.find('video');
        if (videos){
            videos.each(function () {
                var $this_video = $(this);
                $this_video[0].pause();
                $this_video[0].currentTime = 0;
            });
        }
    }

    $body.on('click', function () {
        close_all_cards($('.grilla'));
        var $box = $('.js-box');
        $box.attr('data-select', '');
    });

    $cards.on('click', function (e) {
        e.stopPropagation();
        var $this = $(this);
        openCard( $this );
    });

    $cards.on('mouseenter', function(e){
        var $this = $(this);
        if($this.data('grilla-mouseenter')){
            openCard($this);
        }
    });

    $cards.on('mouseleave', function(e){
        var $this = $(this);
        if( $this.data('grilla-mouseenter')){
            close_all_cards($('.grilla'));
            var $box = $('.js-box');
            $box.attr('data-select', '');
        }
    })



    function openCard($card){
        var $grilla = $card.closest('.grilla');
        var $class = $card.data('grilla-class');
        var video = $card.find('video');

        var $col_open = $card.data('col');
        var $box = $card.closest('.js-box');
        $box.attr('data-select', $col_open);

        var $top = $card.closest('.grilla__top');
        var $bottom = $card.closest('.grilla__bottom');
        var $seccion_bottom = $card.closest('.grilla__right');

        close_all_cards($grilla);

        if (video[0]){
            video[0].play();
        }

        if ($top){$top.addClass('is-open');}
        if ($bottom){$bottom.addClass('is-open');}
        if ($seccion_bottom){$seccion_bottom.addClass('is-here');}

        $grilla.addClass($class);
        $card.addClass('open');
        $card.removeClass('image-visible');
    }

    $btn_close.on('click', function (e) {
        e.stopPropagation();
        var $this = $(this);
        var $grilla = $this.closest('.grilla');
        var card = $this.closest('.js-card');
        var video = card.find('video');

        var $box = $this.closest('.js-box');
        $box.attr('data-select', '');

        if (video[0]){
            video[0].pause();
            video[0].currentTime = 0;
        }

        close_all_cards($grilla);
    });

});
